<!--suppress ALL -->
<template>
    <div class="articleEdit">
        <!-- <div class="header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <div class="tab">作者投稿</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>-->
        <div class="main" @click="expand">
            <div class="editInfo">
                <el-form
                    :model="artInfo"
                    size="mini"
                    :rules="rules"
                    ref="addInfo"
                >
                    <el-form-item
                        label="文章标题："
                        prop="title"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            placeholder="请输入"
                            v-model="artInfo.title"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item
                        label="文章分类："
                        prop="class"
                        :label-width="formLabelWidth"
                    >
                        <nav-select
                            :single="false"
                            @getNav="navChange"
                        />
                    </el-form-item>
                    <el-form-item
                        label="发布人："
                        prop="release_user"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            placeholder="请输入"
                            v-model="artInfo.release_user"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item
                        label="联系方式："
                        prop="phone"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            placeholder="请输入"
                            v-model="artInfo.phone"
                            type="number"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item
                        label="文章来源："
                        prop="source"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            placeholder="请输入"
                            v-model="artInfo.source"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item
                        label="文章类别："
                        prop="type"
                        :label-width="formLabelWidth"
                    >
                        <el-select
                            :size="inputSize"
                            v-model="artInfo.type"
                            placeholder="请选择"
                            @change="typeChange"
                        >
                            <el-option
                                v-for="item in artType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="文章摘要："
                        prop="description"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            placeholder="请输入"
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 8 }"
                            style="width: 80%;"
                            v-model="artInfo.description"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item
                        label="关键词："
                        :label-width="formLabelWidth"
                        v-if="titleList.length"
                    >
                        <div
                            class="inline-left"
                            v-for="(item, i) in titleList"
                            :key="i"
                        >
                            <el-input
                                v-model="item.name"
                                style="width:150px"
                                :size="inputSize"
                                placeholder="添加新条目"
                            />
                            <el-input
                                placeholder="新条目的输入框"
                                v-model="item.value"
                                :size="inputSize"
                                style="margin-left:10px"
                            />
                            <i
                                class="el-icon-circle-plus-outline"
                                @click="addTitle"
                                v-if="i == 0"
                            ></i>
                            <i
                                class="el-icon-delete"
                                @click="deleteTitle(i)"
                            ></i>
                        </div>
                    </el-form-item>
                    <el-form-item
                        label="上传附件："
                        prop="attachment"
                        v-show="textHide"
                        :label-width="formLabelWidth"
                    >
                        <up-appendix
                            :file="artInfo.attachment"
                            fileType="2"
                            @getFile="addChangeFile"
                        />
                    </el-form-item>
                    <el-form-item
                        label="上传缩略图："
                        prop="headImg"
                        v-show="textHide"
                        :label-width="formLabelWidth"
                    >
                        <single-img
                            :img="artInfo.img"
                            :Width="160"
                            :Height="120"
                            size="160*120"
                            @getPic="addChangeImg"
                        />
                    </el-form-item>
                </el-form>
                <div class="basic" @click="expand('artShow')">
                    <svg
                        class="icon"
                        aria-hidden="true"
                        :class="{ rotate: artShow }"
                    >
                        <use xlink:href="#icon-expandmore" />
                    </svg>
                    <h1>文本类内容编辑</h1>
                </div>
                <div class="title" v-if="artShow">
                    <WangEditor
                        :text="artInfo.text"
                        class="text"
                        @change="changeText"
                    />
                </div>
                <div class="basic" @click="expand('pdfShow')" v-show="textHide">
                    <svg
                        class="icon"
                        aria-hidden="true"
                        :class="{ rotate: pdfShow }"
                    >
                        <use xlink:href="#icon-expandmore" />
                    </svg>
                    <h1>PDF类内容编辑</h1>
                </div>
                <div class="title" v-if="pdfShow && textHide">
                    <single-pdf
                        :file="artInfo.pdf"
                        fileType="2"
                        @getFile="addChangePDF"
                    />
                </div>
                <div class="basic" @click="expand('videoShow')">
                    <svg
                        class="icon"
                        aria-hidden="true"
                        :class="{ rotate: videoShow }"
                    >
                        <use xlink:href="#icon-expandmore" />
                    </svg>
                    <h1>视频类内容编辑</h1>
                </div>
                <div class="title" v-if="videoShow">
                    <single-video
                        :file="artInfo.video"
                        fileType="2"
                        @getFile="addChangeVideo"
                    />
                </div>
            </div>
        </div>
        <div class="bottom">
            <!-- <el-button @click="preview">预览</el-button>
      <el-button @click="toDraft">保存草稿</el-button>-->
            <el-button type="primary" @click="commit">提交</el-button>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import WangEditor from '../../components/content/wang-edit';
    import SinglePdf from '../../components/content/singlePDF';
    import SingleVideo from '../../components/content/singleVideo';
    import UpAppendix from '../../components/content/upAppendix';
    import SingleImg from '../../components/content/singleImg';
    import NavSelect from '../../components/content/nav-select';

    export default {
        name: 'contribute',
        components: {
            SingleImg,
            UpAppendix,
            SingleVideo,
            SinglePdf,
            WangEditor,
            NavSelect
        },
        data() {
            return {
                inputSize: 'mini',
                method: '',
                classId: this.$route.query.classId, // 分类名称
                formLabelWidth: '100px',
                extraList: [], // 额外条目
                artShow: false,
                videoShow: false,
                pdfShow: false,
                textHide: true,
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ],
                    source: [
                        {
                            required: true,
                            message: '请输入文章来源',
                            trigger: 'blur'
                        }
                    ],
                    release_user: [
                        { required: true, message: '请输入发布人', trigger: 'blur' }
                    ],
                    phone: [
                        {
                            required: true,
                            message: '请输入联系方式',
                            trigger: 'blur'
                        }
                    ],
                    type: [
                        {
                            required: true,
                            message: '请输入文章类别',
                            trigger: 'change'
                        }
                    ],
                    description: [
                        {
                            required: true,
                            message: '请输入文章摘要',
                            trigger: 'blur'
                        }
                    ]
                },
                artType: [
                    {
                        label: '视频',
                        value: 'video'
                    },
                    {
                        label: '文章',
                        value: 'text'
                    }
                ],
                expertList: [
                    {
                        uid: '0',
                        nickname: '无'
                    }
                ], // 专家列表
                titleList: [
                    {
                        name: '',
                        value: ''
                    }
                ],
                artInfo: {
                    extension: [],
                    is_copy: false,
                    map_uid: '', // 关联专家
                    type: '', // 视频或文本
                    title: '', // 文章标题
                    source: '', // 来源
                    write_time: new Date(), // 撰稿时间
                    release_user: JSON.parse(localStorage.getItem('userName')), // 发布人
                    description: '', // 描述
                    text: '', // 文本内容
                    pdf: '', // pdf链接
                    video: '', // 视频链接
                    img: '', // 视频快照
                    status: '', // 审核或是草稿
                    phone: '',
                    class: '',
                    attachment: [] // 附件
                }
            };
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            }
        },
        mounted() {
            if (this.$route.query.id) {
                // 编辑页面, 获取编辑数据
                this.method = 'edit';
                this.getInfo();
            } else {
                this.method = 'add';
            }
        },
        methods: {
            navChange(data) {
                // 选择导航，重新获取分类
                this.artInfo.class = data;
            },
            addTitle() {
                // 添加条目
                let data = {
                    name: '',
                    value: ''
                };
                this.titleList.push(data);
            },
            deleteTitle(i) {
                // 删除关键词
                this.titleList.splice(i, 1);
            },
            addChangeImg(val) {
                // 添加分类上传图片
                this.artInfo.img = val;
            },
            addChangePDF(val) {
                // 切换文件
                this.artInfo.pdf = val;
            },
            typeChange(val) {
                this.textHide = val === 'text';
            },
            addChangeVideo(val) {
                this.artInfo.video = val;
                this.artInfo.img = `${val}?x-oss-process=video/snapshot,t_10000,m_fast`;
            },
            addChangeFile(val) {
                this.artInfo.attachment = val;
            },
            getInfo() {
                // 获取文章详情
                let data = {
                    article_id: this.$route.query.id
                };
                this.loading = true;
                this.httpGet(this.$root.queryArticle, data).then(
                    res => {
                        this.artInfo = res.data;
                        // 获取额外的条目
                        this.titleList = [];
                        this.artInfo.extension.forEach((item, i) => {
                            let array = item.split(':');
                            let data = {
                                name: array[0],
                                value: array[1]
                            };
                            this.titleList.push(data);
                        });

                        // 获取分类，改为el-cascader二维数组
                        this.classId = [];
                        res.data.classItem.map(item => {
                            const id1 = item.id ? item.id : '';
                            const id2 = item.child.id ? item.child.id : '';
                            const id3 = item.child.child ? item.child.child.id : '';
                            let array = [id1, id2, id3].filter(item => item != '');
                            this.classId.push(array);
                        });
                        // console.log(3333,'转换结构', this.classId);
                        // 获取关联专家
                        this.artInfo.map_uid = res.data.map_uid.id;
                        // 转时间戳为标准时间
                        this.artInfo.write_time = this.parserDate(
                            this.artInfo.write_time
                        );
                        // 获取是否复制
                        this.artInfo.is_copy =
                            this.artInfo.is_copy == 1;
                        this.loading = false;
                    },
                    () => {
                        this.loading = false;
                    }
                );
            },
            changeText(val) {
                // 文本更改
                this.artInfo.text = val;
            },
            parserDate(date) {
                let t = Date.parse(date);
                if (!isNaN(t)) {
                    return new Date(Date.parse(date.replace(/-/g, '/')));
                } else {
                    return new Date();
                }
            },
            commit() {
                this.$refs['addInfo'].validate(valid => {
                    if (valid) {
                        // 判断type为text，text必传，type为video，video必传
                        if (
                            this.artInfo.type === 'text' &&
                            this.artInfo.text === '' &&
                            this.artInfo.pdf === ''
                        ) {
                            this.$message({
                                message: '请输入文本内容！',
                                type: 'warning'
                            });
                            return false;
                        }
                        if (
                            this.artInfo.type === 'video' &&
                            this.artInfo.video === ''
                        ) {
                            this.$message({
                                message: '请选择上传视频！',
                                type: 'warning'
                            });
                            return false;
                        }
                        // 提交文章
                        this.artInfo.status = this.$Public.artExamine.wait;
                        this.addSure(() => {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            });
                            // this.$router.go(0);
                        });
                    } else {
                        return false;
                    }
                });
            },
            toDraft() {
                // 保存至草稿箱
                if (this.artInfo.title === '') {
                    this.$message({
                        message: '请输入文章标题！',
                        type: 'warning'
                    });
                    return false;
                }
                // 提交文章
                this.artInfo.status = this.$Public.artExamine.draft;
                this.addSure(() => {
                    this.$message({
                        message: '成功保存至草稿箱',
                        type: 'success'
                    });
                    this.$router.push({
                        name: 'draft'
                    });
                });
            },
            preview() {
                // 预览
                if (this.artInfo.title === '') {
                    this.$message({
                        message: '请输入文章标题！',
                        type: 'warning'
                    });
                    return false;
                }
                // 提交文章
                this.artInfo.status = this.$Public.artExamine.draft;
                this.addSure(id => {
                    this.$router.push({
                        name: 'article-detail',
                        query: {
                            id: id,
                            type: 'edit'
                        }
                    });
                });
            },
            addSure(fun) {
                let request = '';
                let data = {};
                // this.artInfo.is_copy = this.artInfo.is_copy ? 1 : 0;
                this.artInfo.extension = this.titleList.map(item => {
                    return item.name + ':' + item.value;
                });
                this.artInfo.class = this.artInfo.class.map(item => item[item.length - 1]);
                // 判断编辑或是添加
                if (this.method === 'edit') {
                    request = 'editArticle';
                    delete this.artInfo.class;
                    data = {
                        id: this.$route.query.id,
                        ...this.artInfo
                    };
                } else {
                    request = 'addArticle';
                    data = this.artInfo;
                }
                this.loading = true;
                this.httpPost(this.$root[request], data).then(
                    res => {
                        fun(res.id);
                        this.loading = false;
                    },
                    () => {
                        this.loading = false;
                    }
                );
            },
            expand(val) {
                // 展开隐藏
                this[val] = !this[val];
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .articleEdit {
        width: 1180px;
        margin: 0 auto;
        background: white;
        padding: 30px 0;
        flex-y();

        .main {
            width: 1000px;
        }
    }

    .bottom {
        width: 100%;
        z-index: 99;
        display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
        display: -webkit-flex; /* 新版本语法: Chrome 21+ */
        justify-content: center;
        align-items: center;
    }

    .bottom button {
        width: 300px !important;
        height: 60px;
    }

    .icon {
        width: 8px;
        height: 8px;
        fill: gray9;
        margin-right: 10px;
        transition(all, 0.3s);

        &.rotate {
            transform: rotate(180deg);
        }
    }

    .articleEdit >>> .ql-container {
        min-height: 500px !important;
    }

    .title {
        margin-left: 30px;
        padding: 20px 0;
        width: 700px;
        min-height: 860px;
        flex-x(flex-start, flex-start);
        margin-bottom: 30px;

        .text {
            // width: 700px;
            margin-right: 30px;
        }
    }

    .el-input {
        width: 300px;
    }

    i {
        color: blue;
        margin-left: 10px;
        font-size: 20px;
    }

    .el-checkbox {
    }

    .el-textarea {
        width: 300px;
    }

    .inline-left {
        flex-x(flex-start);
        margin-bottom: 15px;
    }

    .main {
        padding-bottom: 80px;

        .tips {
            font-size: 14px;
        }

        .editInfo {
            width: 100%;

            p {
                color: gray6;
                line-height: 28px;
            }

            .label {
                background: grayF6;
                border();
                -webkit-border-radius: main-radius;
                -moz-border-radius: main-radius;
                border-radius: main-radius;
            }

            .basic {
                flex-x(flex-start);
                width: 100%;
                height: 50px;
                background: bk;
                border-radius(3px);
                padding: 0 15px;
                overflow: hidden;
                margin: margin20 0;

                h1 {
                    word(14px);
                    line-height: 50px;
                }
            }
        }

        .detailImg {
            flex-center();

            ul {
                width: 30%;
                margin-top: 40px;

                img {
                    width: 100%;
                }
            }
        }
    }

    .bottom {
        bottom();

        .el-button {
            width: 100px;
        }
    }

    .el-radio {
        width: 100%;
    }

    .el-radio + .el-radio {
        margin-left: 0 !important;
    }

    .el-breadcrumb {
        line-height: 40px;
    }
</style>
